import { render, staticRenderFns } from "./SaveAs.vue?vue&type=template&id=72201e06&scoped=true&"
import script from "./SaveAs.vue?vue&type=script&lang=js&"
export * from "./SaveAs.vue?vue&type=script&lang=js&"
import style0 from "./SaveAs.vue?vue&type=style&index=0&id=72201e06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72201e06",
  null
  
)

export default component.exports